
import axios from "axios";
import { clearStorage } from "../utils/Storage";

/* ============================
   BASE URL
============================ */
// const API_BASE_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://back.redcloudhrms.com/api";

/* ============================
   AXIOS INSTANCE
============================ */
const API = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

/* ============================
   REQUEST INTERCEPTOR
============================ */
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ============================
   RESPONSE INTERCEPTOR
============================ */
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const method = error.config?.method || "";

      // skip login
      if (method === "post" && requestUrl === "/") {
        return Promise.reject(error);
      }

      if (requestUrl.includes("login")) {
        return Promise.reject(error);
      }

      clearStorage();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default API;